import React from 'react';
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { Home } from "./handler";

ReactDOM.hydrate(
  <Home />,
  document.getElementById('root')
);
